import http from "@/utils/http";

// 获取用户信息
export function getUserInfo() {
  return http({
    url: "/user/info",
    method: "GET"
  });
}

// 设置用户信息
export function setUserInfo(data) {
  return http({
    url: "/user/info",
    method: "POST",
    data
  });
}

// 未绑定手机号用户，绑定手机号第一步，获取验证码
export function userBindPhoneMsgcode(data) {
  return http({
    url: "/user/bindphone/msgcode/" + data,
    method: "POST"
  });
}

// 未绑定手机号用户，绑定手机号第二步，提交
export function userBindPhone(data) {
  return http({
    url: "/user/bindphone",
    method: "POST",
    data
  });
}

// 修改密码
export function userChangepass(data) {
  return http({
    url: "/user/changepass",
    method: "POST",
    data
  });
}

// 根据手机号或者用户账号查询用户简要信息
export function userSearch(data) {
  return http({
    url: "/user/search/" + data,
    method: "GET"
  });
}

// 微信登录 请求state
export function getQrState() {
  return http({
    url: '/wx/new/state',
  })
}

// 登录第一步--获取微信二维码
export function getLoginQr(data) {
  return http({
    url: "/user/login/qr?domain=" + data,
    method: "POST"
  });
}

// 登录第二步--轮询探测扫码情况
export function selectLoginQr(ito) {
  return http({
    url: "/user/login/wx",
    method: "POST",
    headers: { ito }
  });
}

// 绑定微信第一步--获取微信二维码（登录的情况下操作  绑定微信）
export function getBindQr() {
  return http({
    url: "/user/bind/qr",
    method: "POST"
  });
}

// 绑定微信第二步--轮询探测扫码情况 （登录的情况下操作  绑定微信）
export function bindWeChat() {
  return http({
    url: "/user/bind",
    method: "POST"
  });
}

// 解绑微信
export function unBindWeChat() {
  return http({
    url: "/wx/new/unbind",
  });
}

// 获取权限
export function getUserRole() {
  return http({
    url: "/user/role/auths",
    method: "POST"
  });
}

// 获取用户所在机构信息
export function getCompanyInfo() {
  return http({
    url: "/user/org/info",
    method: "GET"
  });
}

// 密码授权--授权/取消授权
export function setPassAuthOrg() {
  return http({
    url: "/user/authorg/setpass",
    method: "POST"
  });
}

// 重置学生密码
export function resetStuPass(data) {
  return http({
    url: "/user/org/setpass",
    method: "POST",
    data
  });
}

